// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  LOGIN_CHANGE_ROLE,
} from './constants';

export function changeRole(role) {
  return {
    type: LOGIN_CHANGE_ROLE,
    payload: {role}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case LOGIN_CHANGE_ROLE:
      return {
        ...state,
        userRole:action.payload.role,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/login/redux/changeRole.js